/* Currently this file contains any necessary helper-functions
   in JS that are used throughout the application.  

   TODO: turn into mixin?
*/

import { bus } from "@/main";
export default {
    getDepartmentSkinFromPage: function (page) {
        if (page.get_skin) {
            bus.$emit("changeSkin", page.get_skin);
            return page.get_skin
        }
        else
            bus.$emit("changeSkin", false);
        return false
    },
    setDepartmentSkin: function (skin_name) {
        if (skin_name) {
            bus.$emit("changeSkin", skin_name);
            return skin_name;
        }
        else {
            bus.$emit("changeSkin", false);
            return false;
        }
    },
    extractParentSlug: function (parent_html_url) {
        /* Retrieves slug of DepartmentLandingPage which is parent to this page. */

        var url_ary = parent_html_url.split("/");
        var slug = url_ary[url_ary.length - 2];
        return slug;
    },
    getDate: function(date) {
        /* Transforms wagtail date into proper format for Date() */
        
        var year = date.slice(0,4);
        var month = date.slice(5,7);
        month = month - 1;
        var day = date.slice(8,10);
        return new Date(year, month, day);
    },
    TwelveHrTime: function(time) {
        if (!time) return '';

        /* Turn into 12 hr time */

        var intTime = time.slice(0,2);
        var TwelveHr = intTime % 12 || 12;
        TwelveHr = TwelveHr.toString() + ':00';
        if (intTime < 12) {
            TwelveHr = TwelveHr + ' AM';
        }
        else {
            TwelveHr = TwelveHr + ' PM';
        }
        return TwelveHr;
    },
    extractTypeFromWagtailType: function (type) {
        /* Retrieves Type from wagtail type IE. "type": "blog.BlogAuthorsOrderable" to lowercase blogauthorsorderable for routing */
        type = type.split('.').pop();
        type = type.toLowerCase();
        return type;
    },
}